const icons = {
  serviceType: '/static/serviceType.png',
  location: '/static/location.png'
}

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const filterOptions = [
  {
    ...publicOptions,
    name: '服务类型',
    icon: icons.serviceType,
    prop: 'thirdServiceType',
    tagList: [
      { name: '知识产权', value: 1, key: 'thirdServiceType1' },
      { name: '资质认证', value: 2, key: 'thirdServiceType2' },
      { name: '法律服务', value: 3, key: 'thirdServiceType3' },
      { name: '金融服务', value: 4, key: 'thirdServiceType4' },
      { name: '培训辅导', value: 5, key: 'thirdServiceType5' },
      { name: '信息服务', value: 6, key: 'thirdServiceType6' }
      // { name: '不限', value: '', key: 'thirdServiceType' }
    ]
  },
  {
    ...publicOptions,
    name: '服务区域',
    icon: icons.location,
    prop: 'area',
    tagList: [
      { name: '北京', value: '北京', key: '北京' },
      { name: '上海', value: '上海', key: '上海' },
      { name: '天津', value: '天津', key: '天津' },
      { name: '重庆', value: '重庆', key: '重庆' },
      { name: '江苏', value: '江苏', key: '江苏' },
      { name: '广东', value: '广东', key: '广东' },
      { name: '山东', value: '山东', key: '山东' },
      { name: '浙江', value: '浙江', key: '浙江' },
      { name: '四川', value: '四川', key: '四川' },
      { name: '河北', value: '河北', key: '河北' },
      { name: '湖北', value: '湖北', key: '湖北' },
      { name: '福建', value: '福建', key: '福建' },
      { name: '辽宁', value: '辽宁', key: '辽宁' },
      { name: '河南', value: '河南', key: '河南' },
      { name: '安徽', value: '安徽', key: '安徽' },
      { name: '湖南', value: '湖南', key: '湖南' },
      { name: '陕西', value: '陕西', key: '陕西' },
      { name: '广西', value: '广西', key: '广西' },
      { name: '江西', value: '江西', key: '江西' },
      { name: '山西', value: '山西', key: '山西' },
      { name: '黑龙江', value: '黑龙江', key: '黑龙江' },
      { name: '吉林', value: '吉林', key: '吉林' },
      { name: '贵州', value: '贵州', key: '贵州' },
      { name: '云南', value: '云南', key: '云南' },
      { name: '新疆', value: '新疆', key: '新疆' },
      { name: '甘肃', value: '甘肃', key: '甘肃' },
      { name: '内蒙古', value: '内蒙古', key: '内蒙古' },
      { name: '海南', value: '海南', key: '海南' },
      { name: '宁夏', value: '宁夏', key: '宁夏' },
      { name: '青海', value: '青海', key: '青海' },
      { name: '西藏', value: '西藏', key: '西藏' },
      { name: '其他地区', value: '其他地区', key: '其他地区' }
    ]
  }
]

module.exports = {
  filterOptions
}
